<template>
    <div class="tables">
        <div class="d-flex justify-content-between align-items-center" style="flex-wrap: wrap;">
            <router-link class="mr-3" :to="{ name: 'checkpoints-checkin', params:{ id: $route.params.checkpointId } }">
                <el-tooltip content="Scanner" placement="top">
                    <el-button title="More">
                        Back to checkin page
                    </el-button>
                </el-tooltip>
            </router-link>

            <div>
                <el-button @click="downloadAsReport" :loading="loading" class="btn btn-primary">
                    Download
                    <fa class="ml-2" icon="download"/>
                </el-button>
                <el-button
                    title="Search Using QR"
                    @click="scannerDialogOpen = true"
                >
                    Search Using QR
                </el-button>
    
                <el-button @click="refresh" :loading="loading" class="btn btn-secondary">
                    Refresh
                </el-button>
            </div>
            
        </div>
        <div class="d-flex justify-content-between align-items-center" style="flex-wrap: wrap;">
            <el-input
                v-model="filter.code"
                placeholder="Code"
                class="col-12 col-sm m-0 p-0 mr-3"
                style="min-width: 250px;"
            />
            <el-input
                v-model="filter.regNoOrId"
                placeholder="Registration"
                class="col-12 col-sm m-0 p-0 mr-3"
                style="min-width: 250px;"
            />
            <el-input
                v-model="filter.name"
                placeholder="Registrant Name (lastname, firstname)"
                class="col-12 col-sm m-0 p-0 mr-3"
                style="min-width: 250px;"
            />
            <CustomSelect 
                style="width: 250px;"
                class="mr-3"
                placeholder="Select filters"
                multiple
                v-model="filter.status"
                :options="[
                    { label: 'Printed', value: 'printed' },
                    { label: 'Checked In', value: 'checked-in' },
                    { label: 'Checked Out', value: 'checked-out' },
                    { label: 'Accepted', value: 'accepted' },
                    { label: 'Deleted', value: 'deleted' }]
                " 
            />
            <el-button @click="runFilter" class="btn">Search</el-button>
        </div>

        <div class="d-flex align-items-center" style="gap:10px; flex-wrap: wrap;">
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Checked-In: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ getTotalCheckedInCount }},</span>
            </p>
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Accepted: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ getTotalAcceptedCount }},</span>
            </p>
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Checked-out: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ getTotalCheckedOutCount }}</span>
            </p>
            <p class="d-flex align-items-center" style="gap:7px;">
                <span style="">Deleted: </span>
                <span style="font-weight: bold; font-size: 1.1rem;">{{ getTotalDeletedCount }}</span>
            </p>
        </div>

        
        <div v-if="initializing" class="d-flex justify-content-center py-4">
            <Loading />
        </div>
        <div v-else-if="checkins.length > 0" style="position: relative; border: 1px solid rgb(160, 160, 160);" v-for="(checkin, idx) in checkins" :key="checkin._id">
            <div style="position: absolute; top: -9px; z-index:100; left: 50px; display: flex; gap:5px;">
                <el-tag class="border status-tag" 
                    :style="getColorForStatus(checkin.status)"
                >
                    {{ checkin.status }}
                </el-tag>
                
                <el-tag class="bg-secondary border">
                    {{ checkin.attendees.length }}
                </el-tag>
                <el-tag 
                    v-if="checkin.printed"
                    class="border status-tag" 
                    :style="getColorForStatus('printed')"
                >
                    printed
                </el-tag>
            </div>
            <div class="responsive-table">
                <table>
                    <thead>
                            <th>
                                <el-dropdown
                                    placement="top-start"
                                    trigger="click"
                                    @command="execCommand"
                                >
                                    <span class="el-dropdown-link">
                                        <!-- <el-tooltip content="More" placement="top-start"> -->
                                            <el-button size="mini" title="More">
                                                <fa :icon="['fas', 'ellipsis-v']" />
                                            </el-button>
                                        <!-- </el-tooltip> -->
                                    </span>
                                    <el-dropdown-menu slot="dropdown" >
                                        <el-dropdown-item v-if="!['deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'printed'}" >Print</el-dropdown-item>
                                        <el-dropdown-item v-if="!['deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'deleted'}" >Delete</el-dropdown-item>
                                        <el-dropdown-item v-if="!['accepted', 'deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'accepted'}" >Accept</el-dropdown-item>
                                        <el-dropdown-item v-if="['accepted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'checked-in'}" >Remove Accepted</el-dropdown-item>
                                        <el-dropdown-item v-if="!['deleted'].includes(checkin.status)" :command="{idx, data: checkin, action: 'checked-out'}" >Checkout</el-dropdown-item>
                                        <el-dropdown-item :command="{idx, data: checkin, action: 'edit'}" >Add / Update Note</el-dropdown-item>
                                        <el-dropdown-item :command="{idx, data: checkin, action: 'view-registration'}" >View Registration</el-dropdown-item>
                                        <el-dropdown-item :command="{idx, data: checkin, action: 'view-logs'}" >View Logs</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </th>
                            <th style="min-width: 180px;">Name</th>
                            <th style="min-width: 150px;">Timestamp</th>
                            <th v-for="cf in fieldsToShow">
                                {{ cf.title }}
                            </th>
                    </thead>
        
                    <tbody>
                        <tr v-for="att in checkin.attendees">
                            <td>
                                <el-tooltip content="Edit" placement="top">
                                    <el-button @click="editAttendee(att)" size="mini" title="More">
                                        <fa :icon="['fas', 'pen']" />
                                    </el-button>
                                </el-tooltip>
                            </td>
                            <td>{{ att | registrationName }}</td>
                            <td>{{ checkin.createdAt | formatTimestamp }}</td>
                            <td v-for="fd in fieldsToShow">
                                <template v-if="fd.type == 'radio'">
                                    {{ fd.labels.split('\n')[fd.values.split('\n').indexOf(getValueForField(fd._id, att))] }}
                                </template>
                                <template>
                                    {{ getValueForField(fd._id, att) }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="p-3 d-flex align-items-center" style="font-size: 1rem; gap:20px;">
                    <div>
                        <span class="mr-2"> Code: </span>
                        <span style="font-weight: bold; font-size: 1.2rem;">{{ checkin.code }}</span>
                    </div>
                    <div>
                        <span class="mr-2">Registration: </span>
                        <span style="font-weight: bold; font-size: 1.2rem;">{{ checkin.attendees[0].confirmationNumber }}</span>
                    </div>
                </div>

                <p v-if="checkin.note" class="pl-3" style="font-size: 1rem; display: flex; gap:5px;">
                    <span class="mr-2">Note: </span>
                    <span class="quill-editor" v-html="checkin.note"></span>
                </p>
            </div>
        </div>
        <div v-else class="d-flex justify-content-center align-items-center py-4">
            
            <div class="d-flex justify-content-center align-items-center py-4" style="flex-direction: column; gap:10px" v-if="filter.regNoOrId">
                <div>No checkins yet</div>
                <div>
                    Try checking in
                    <router-link
                        :to="{ 
                            name: 'checkpoints-checkin', 
                            params: { type: 'checkpoint', id: $route.params.checkpointId },
                            query: { regNoOrId: filter.regNoOrId },
                        }"
                    >
                        Checkin
                    </router-link>
                </div>
            </div>
        </div>


        <el-dialog 
            :close-on-click-modal="false"
            :visible.sync="viewingPrimaryRegDialog">
            <label for="notes" style="font-size: 1rem;">Primary Registration</label>
            <pre v-html="primaryRegDetails" ></pre>
        </el-dialog>

        <el-dialog 
            :close-on-click-modal="false"
            :visible.sync="noteData.dialogOpen">
            <label for="notes" style="font-size: 1rem;">Notes</label>
            <Editor id="notes" v-model="noteData.checkin.note" />
            <el-button @click="updateCheckinNote" :loading="loading" style="width: 100%;" class="btn btn-primary mt-4">Save</el-button>
        </el-dialog>

        <el-dialog
            v-if="scannerDialogOpen"
            :close-on-click-modal="false"
            :visible.sync="scannerDialogOpen">
            <QrScanner @onDecode="searchUsingScanner" />
            <p class="d-flex justify-content-center mt-2" style="color: gray;">Switch camera here if needed</p>
        </el-dialog>

        <el-dialog
            v-if="editData.dialogOpen"
            :close-on-click-modal="false"
            :visible.sync="editData.dialogOpen">
            <div style="background: #fff;" class="p-2">
                <template v-if="editData.fields.length">
                    <CheckinDataForm
                        hideEditButton
                        class="my-3"
                        :fields="editData.fields" 
                        :registration="editData.registration"
                        @change="handleCheckpointFieldDataChange"
                        mode="edit"
                    />
                    <el-button :loading="editData.loading" @click="updateFields" class="mt-2" style="width: 100%">Save</el-button>
                </template>
                <template v-else>
                    <p class="d-flex justify-content-center">No fields to edit</p>
                </template>
            </div>
        </el-dialog>

        <el-dialog
            v-if="logData.dialogOpen"
            :close-on-click-modal="false"
            :visible.sync="logData.dialogOpen">
            <div v-if="logData.loading" class="d-flex justify-content-center">
                <Loading />
            </div>
            <p v-else-if="logData.logs.length == 0" class="d-flex justify-content-center py-4">No logs to show</p>
            <div v-else>
                <el-table
                    :data="logData.logs">
                        <!-- <el-table-column label="Attendee">
                            <template slot-scope="props">
                                {{ props.row.RegistrantFirstName }} {{ props.row.RegistrantLastName }}
                            </template>
                        </el-table-column> -->
                        <el-table-column label="Change">
                            <template slot-scope="props">
                                {{ props.row.data.status }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Timestamp">
                            <template slot-scope="props">
                                {{ props.row.createdAt | formatTimestamp }}
                            </template>
                        </el-table-column>
                        <el-table-column label="By">
                            <template slot-scope="props">
                                {{ getCreator(props.row.creator) }}
                            </template>
                        </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import http from '../../http'
import Editor from '../../components/Editor.vue'
import Loading from "../Loading.vue"
import CustomSelect from "../../components/CustomSelect.vue"
import QrScanner from '../../components/QrScanner.vue'
import CheckinDataForm from "../../components/CheckinDataForm.vue"
import { mapState } from 'vuex';
import download from 'downloadjs'
import swal from 'sweetalert2';

export default {
    components: {
        Editor,
        Loading,
        CustomSelect,
        QrScanner,
        CheckinDataForm
    },
    props:{
        checkpointId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            checkpoint: null,
            checkins:[],
            checkinsBackup:[],
            initializing: false,
            loading: false,
            viewingPrimaryRegDialog: false,
            primaryRegDetails: null,
            noteData:{
                dialogOpen: false,
                idx: null,
                checkin: {
                    note: ""
                },
            },
            filter:{
                status: [],
                name: null,
                regNoOrId: null,
                code: null
            },
            scannerDialogOpen: false,
            fieldDatas: [],
            checkpointFields: [],
            editData:{
                fields: [],
                registration: {},
                recordedCheckpointFieldData: [],
                dialogOpen: false,
                loading: false
            },
            fieldsToShow: [],
            logData:{
                logs: [],
                dialogOpen: false,
                loading: false
            },
            downloading: false
        }
    },
    computed:{
        ...mapState(['fields', 'checkpoints']),
        getTotalCheckedInCount(){
            let count = 0;
            this.checkins.forEach(ch =>{
                if(ch.status == "checked-in"){
                    count += ch.attendees.length;
                }
            })
            return count;
        },
        getTotalCheckedOutCount(){
            let count = 0;
            this.checkins.forEach(ch =>{
                if(ch.status == "checked-out"){
                    count += ch.attendees.length;
                }
            })
            return count;
        },
        getTotalAcceptedCount(){
            let count = 0;
            this.checkins.forEach(ch =>{
                if(ch.status == "accepted"){
                    count += ch.attendees.length;
                }
            })
            return count;
        },
        getTotalDeletedCount(){
            let count = 0;
            this.checkins.forEach(ch =>{
                if(ch.status == "deleted"){
                    count += ch.attendees.length;
                }
            })
            return count;
        }
    },
    methods: {
        async getLogs(checkinId){
            this.logData.dialogOpen = true;
            this.logData.loading = true
            try {
                const res = await http.get(`/api/checkpoint-log/checkin?checkinId=${checkinId}`);
                this.logData.logs = res.data.logs
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
            this.logData.loading = false
        },
        print(checkin) {
            let checkpointName = this.checkpoint.name;
            let code = checkin.code;
            let confirmationNumber = checkin.attendees[0].confirmationNumber;
            let labels = []

            checkin.attendees.forEach(at =>{
                let names = this.getNameFromRegistration(at).split(',')
                labels.push(
                    `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                            <PaperOrientation>Landscape</PaperOrientation>
                            <Id>ZipDisk</Id>
                            <IsOutlined>false</IsOutlined>
                            <PaperName>30370 Zip Disk</PaperName>
                            <DrawCommands>
                                <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                            </DrawCommands>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${checkpointName}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="344" Y="1527" Width="1764" Height="311.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <BarcodeObject>
                                    <Name>BARCODE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <Text>${at._id}</Text>
                                    <Type>QRCode</Type>
                                    <Size>Large</Size>
                                    <TextPosition>None</TextPosition>
                                    <TextFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <CheckSumFont Family="Arial" Size="8" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                    <TextEmbedding>None</TextEmbedding>
                                    <ECLevel>0</ECLevel>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <QuietZonesPadding Left="0" Top="0" Right="0" Bottom="0" />
                                </BarcodeObject>
                                <Bounds X="2163" Y="1395" Width="1095" Height="1044" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <ShapeObject Stroke="SolidLine">
                                    <Name>SHAPE</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <ShapeType>HorizontalLine</ShapeType>
                                    <LineWidth>15</LineWidth>
                                    <LineAlignment>Center</LineAlignment>
                                    <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                                </ShapeObject>
                                <Bounds X="317" Y="1350" Width="2775" Height="15" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_1</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[1].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="24" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="195" Width="2851" Height="497.999999999999" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_2</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${names[0].toUpperCase()}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="20" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="843.000000000001" Width="2805" Height="366" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_3</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${code}</String>
                                            <Attributes>
                                                <Font Family="Britannic" Size="14" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="1983" Width="1798" Height="357" />
                            </ObjectInfo>
                            <ObjectInfo>
                                <TextObject>
                                    <Name>TEXT_4</Name>
                                    <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                    <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                    <LinkedObjectName />
                                    <Rotation>Rotation0</Rotation>
                                    <IsMirrored>False</IsMirrored>
                                    <IsVariable>False</IsVariable>
                                    <GroupID>-1</GroupID>
                                    <IsOutlined>False</IsOutlined>
                                    <HorizontalAlignment>Center</HorizontalAlignment>
                                    <VerticalAlignment>Top</VerticalAlignment>
                                    <TextFitMode>ShrinkToFit</TextFitMode>
                                    <UseFullFontHeight>True</UseFullFontHeight>
                                    <Verticalized>False</Verticalized>
                                    <StyledText>
                                        <Element>
                                            <String xml:space="preserve">${ confirmationNumber} | ${ checkin.attendees.length }</String>
                                            <Attributes>
                                                <Font Family="Century Gothic" Size="12" Bold="True" Italic="False" Underline="False" Strikeout="False" />
                                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                            </Attributes>
                                        </Element>
                                    </StyledText>
                                </TextObject>
                                <Bounds X="317" Y="2494" Width="2835" Height="165" />
                            </ObjectInfo>
                        </DieCutLabel>
                `)
            });

            labels.push(
                `<?xml version="1.0" encoding="utf-8"?>
                        <DieCutLabel Version="8.0" Units="twips">
                        <PaperOrientation>Landscape</PaperOrientation>
                        <Id>ZipDisk</Id>
                        <IsOutlined>false</IsOutlined>
                        <PaperName>30370 Zip Disk</PaperName>
                        <DrawCommands>
                            <RoundRectangle X="0" Y="0" Width="2880" Height="3375" Rx="270" Ry="270" />
                        </DrawCommands>
                        <ObjectInfo>
                            <TextObject>
                                <Name>TEXT</Name>
                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                <LinkedObjectName />
                                <Rotation>Rotation0</Rotation>
                                <IsMirrored>False</IsMirrored>
                                <IsVariable>False</IsVariable>
                                <GroupID>-1</GroupID>
                                <IsOutlined>False</IsOutlined>
                                <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                <VerticalAlignment>Top</VerticalAlignment>
                                <TextFitMode>ShrinkToFit</TextFitMode>
                                <UseFullFontHeight>True</UseFullFontHeight>
                                <Verticalized>False</Verticalized>
                                <StyledText>
                                    <Element>
                                        <String xml:space="preserve">${checkpointName}</String>
                                        <Attributes>
                                            <Font Family="Britannic" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                        </Attributes>
                                    </Element>
                                </StyledText>
                            </TextObject>
                            <Bounds X="359" Y="1677" Width="2769" Height="371.999999999999" />
                        </ObjectInfo>
                        <ObjectInfo>
                            <ShapeObject Stroke="SolidLine">
                                <Name>SHAPE</Name>
                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                <LinkedObjectName />
                                <Rotation>Rotation0</Rotation>
                                <IsMirrored>False</IsMirrored>
                                <IsVariable>False</IsVariable>
                                <GroupID>-1</GroupID>
                                <IsOutlined>False</IsOutlined>
                                <ShapeType>HorizontalLine</ShapeType>
                                <LineWidth>15</LineWidth>
                                <LineAlignment>Center</LineAlignment>
                                <FillColor Alpha="0" Red="255" Green="255" Blue="255" />
                            </ShapeObject>
                            <Bounds X="317" Y="1470" Width="2880" Height="15" />
                        </ObjectInfo>
                        <ObjectInfo>
                            <TextObject>
                                <Name>TEXT_1</Name>
                                <ForeColor Alpha="255" Red="255" Green="255" Blue="255" />
                                <BackColor Alpha="255" Red="27" Green="27" Blue="27" />
                                <LinkedObjectName />
                                <Rotation>Rotation0</Rotation>
                                <IsMirrored>False</IsMirrored>
                                <IsVariable>False</IsVariable>
                                <GroupID>-1</GroupID>
                                <IsOutlined>False</IsOutlined>
                                <HorizontalAlignment>Center</HorizontalAlignment>
                                <VerticalAlignment>Top</VerticalAlignment>
                                <TextFitMode>ShrinkToFit</TextFitMode>
                                <UseFullFontHeight>True</UseFullFontHeight>
                                <Verticalized>False</Verticalized>
                                <StyledText>
                                    <Element>
                                        <String xml:space="preserve">${code}</String>
                                        <Attributes>
                                            <Font Family="Britannic" Size="20" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                            <ForeColor Alpha="255" Red="255" Green="255" Blue="255" HueScale="100" />
                                        </Attributes>
                                    </Element>
                                </StyledText>
                            </TextObject>
                            <Bounds X="317" Y="315" Width="2851" Height="467.999999999999" />
                        </ObjectInfo>
                        <ObjectInfo>
                            <TextObject>
                                <Name>TEXT_2</Name>
                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                <LinkedObjectName />
                                <Rotation>Rotation0</Rotation>
                                <IsMirrored>False</IsMirrored>
                                <IsVariable>False</IsVariable>
                                <GroupID>-1</GroupID>
                                <IsOutlined>False</IsOutlined>
                                <HorizontalAlignment>Center</HorizontalAlignment>
                                <VerticalAlignment>Top</VerticalAlignment>
                                <TextFitMode>ShrinkToFit</TextFitMode>
                                <UseFullFontHeight>True</UseFullFontHeight>
                                <Verticalized>False</Verticalized>
                                <StyledText>
                                    <Element>
                                        <String xml:space="preserve">${checkin.attendees.length}</String>
                                        <Attributes>
                                            <Font Family="Britannic" Size="16" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                        </Attributes>
                                    </Element>
                                </StyledText>
                            </TextObject>
                            <Bounds X="317" Y="903.000000000001" Width="2700" Height="456" />
                        </ObjectInfo>
                        <ObjectInfo>
                            <TextObject>
                                <Name>TEXT_3</Name>
                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                <LinkedObjectName />
                                <Rotation>Rotation0</Rotation>
                                <IsMirrored>False</IsMirrored>
                                <IsVariable>False</IsVariable>
                                <GroupID>-1</GroupID>
                                <IsOutlined>False</IsOutlined>
                                <HorizontalAlignment>Center</HorizontalAlignment>
                                <VerticalAlignment>Top</VerticalAlignment>
                                <TextFitMode>ShrinkToFit</TextFitMode>
                                <UseFullFontHeight>True</UseFullFontHeight>
                                <Verticalized>False</Verticalized>
                                <StyledText>
                                    <Element>
                                        <String xml:space="preserve">${confirmationNumber}</String>
                                        <Attributes>
                                            <Font Family="Britannic" Size="10" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                        </Attributes>
                                    </Element>
                                </StyledText>
                            </TextObject>
                            <Bounds X="347.999999999999" Y="2103" Width="2772" Height="312" />
                        </ObjectInfo>
                        <ObjectInfo>
                            <TextObject>
                                <Name>TEXT_4</Name>
                                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                                <LinkedObjectName />
                                <Rotation>Rotation0</Rotation>
                                <IsMirrored>False</IsMirrored>
                                <IsVariable>False</IsVariable>
                                <GroupID>-1</GroupID>
                                <IsOutlined>False</IsOutlined>
                                <HorizontalAlignment>CenterBlock</HorizontalAlignment>
                                <VerticalAlignment>Top</VerticalAlignment>
                                <TextFitMode>ShrinkToFit</TextFitMode>
                                <UseFullFontHeight>True</UseFullFontHeight>
                                <Verticalized>False</Verticalized>
                                <StyledText>
                                    <Element>
                                        <String xml:space="preserve">Retain this label for Checkout</String>
                                        <Attributes>
                                            <Font Family="Arial" Size="10" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                                        </Attributes>
                                    </Element>
                                </StyledText>
                            </TextObject>
                            <Bounds X="317" Y="2434" Width="2880" Height="330" />
                        </ObjectInfo>
                        </DieCutLabel>
                `)

            console.log(labels);

            let done = false;
            dymo.label.framework.trace = true;
            dymo.label.framework.init(() => {
                const printers = dymo.label.framework.getPrinters();

                if (!printers.length) {
                    console.log("no supported printers found");
                    return done;
                }

                try {

                    for(let labelXml of labels){
                        const label = dymo.label.framework.openLabelXml(labelXml);
                        label.print("DYMO LabelWriter 450");
                    }
                    done = true;
                } catch (error) {
                    console.log(error);
                }
            });

            return done;
        },
        editAttendee(att){
            this.editData.registration = att;
            this.editData.recordedCheckpointFieldData = []
            this.editData.fields = []
            let data = this.fieldDatas.find(el => el.registration == att._id);
            this.fieldsToShow.forEach(f =>{
                let field = { ...f, value: "" }
                if(data && data.fields.length){
                    data.fields.forEach(el =>{
                        if(field._id == el._id){
                            field.value = el.value
                        }
                    })
                }
                else{
                    let val = this.getFieldValueFromRegistration(f._id, att);
                    if(val) field.value = val;
                }
                this.editData.fields.push(field);
            })
            this.editData.dialogOpen = true
        },
        handleCheckpointFieldDataChange(output){
            this.removeCheckpointFieldData(output.registration);
            this.editData.recordedCheckpointFieldData.push(output);
        },
        removeCheckpointFieldData(regId){
            this.editData.recordedCheckpointFieldData = this.editData.recordedCheckpointFieldData.filter(data => data.registration != regId);
        },
        getValueForField(id, reg){
            const found = this.fieldDatas.find(el => el.registration == reg._id);
            if(!found) {
                let val = this.getFieldValueFromRegistration(id, reg)
                if(val) return val;
                return ""
            }
            let field = found.fields.find(f => f._id == id)
            if(field == -1) return "";
            return field && field.value ? field.value : "";
        },
        getFieldValueFromRegistration(fieldId, registration){
            if(fieldId){
                let regFields = registration.fields;
                let field = regFields.find(el => el._id == fieldId)
                if(field && field.value != undefined) return field.value;
            }
            return null
        },
        searchUsingScanner(id){
            this.scannerDialogOpen = false
            if (!id || !id.length) {
                return;
            }
            let confirmationNumber = null
            for(let i = 0; i < this.checkins.length; i++){
                const attendees = this.checkins[i].attendees;
                let at = attendees.find(at => at._id == id)
                if(at) {
                    confirmationNumber = at.confirmationNumber;
                    break;
                }
            }

            this.filter.regNoOrId = confirmationNumber
            this.runFilter()
        },
        runFilter(){
            this.checkins = this.checkinsBackup.filter(el=>{
                if(this.filter.code){
                    return String(el.code).toUpperCase() == String(this.filter.code).toUpperCase();
                }

                let status = this.filter.status ? this.filter.status :  [];
                if(status.length){
                    if(status.includes("printed")) return el.printed;
                    return status.includes(el.status)
                }


                if(this.filter.name || this.filter.regNoOrId){
                    let found = false
                    el.attendees.find(at =>{
                        if(this.filter.name){
                            let name = this.getNameFromRegistration(at);
                            let names = this.filter.name.split(',')
                            names.forEach((el, i) => {
                                names[i] = el.trim()
                            });
                            let fullName = names.join(",")
                            if(name.toUpperCase().indexOf(fullName.toUpperCase()) != -1){
                                found = true;
                            }
                        }else if(at.confirmationNumber == this.filter.regNoOrId || at._id == this.filter.regNoOrId){
                            found = true
                        }
                        return found;
                    })
                    return found;
                }

                if(status.length == 0 && !this.filter.name && !this.filter.regNoOrId) return true;
                
                return false;
            })
        },
        async execCommand(obj){
            if(obj.action == "view-logs") {
                this.getLogs(obj.data._id)
                return;
            }
            if(obj.action == "edit") {
                this.noteData.dialogOpen = true
                this.noteData.idx = obj.idx
                this.noteData.checkin = {
                    ...obj.data
                }
                return;
            }
            if(obj.action == "view-registration") {
                if(!obj.data.primaryRegistrant) return this.$notify({ type: "danger", message: "primary registration id unavailable" });
                this.$router.push({ name : 'attendees',  query : { confirmationNumber: obj.data.attendees[0].confirmationNumber }})
                return;
            }

            if(this.checkins[obj.idx].status == "deleted") return;
            
            if(obj.action == "printed") {
                this.print(obj.data);
            }
            if(obj.action == "deleted") {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete ? You won't be able to revert it back.`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (!confirmed)  return;
            }

            try {
                const res = await http.put('/api/checkpoints/checkin-status', { 
                    eventId: this.$route.params.eventId, 
                    checkinId: obj.data._id,
                    status: obj.action
                });

                if(obj.action == "printed") this.checkins[obj.idx].printed = true;
                else this.checkins[obj.idx].status = obj.action;

                this.$notify({
                    message: res.data.message,
                    type: "info"
                })

            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
        },
        async updateCheckinNote(){
            this.loading = true
            try {
                const res = await http.put('/api/checkpoints/checkin-note', { 
                    eventId: this.$route.params.eventId, 
                    checkinId: this.noteData.checkin._id,
                    note: this.noteData.checkin.note
                });

                this.checkins[this.noteData.idx].note = this.noteData.checkin.note;

                this.$notify({
                    message: res.data.message,
                    type: "info"
                })
                this.noteData.dialogOpen = false
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
                console.log(error);
                this.$notify({
                    message: "something went wrong",
                    type: "danger"
                })
            }
            this.loading = false
        },
        getColorForStatus(status){
            if(status == "checked-out") return "background: #000;";
            if(status == "accepted") return "background: green;";
            if(status == "printed") return "background: #409EFF;";
            if(status == "deleted") return "background: #e70202;";

            return "background: #e7ad02;"
        },
        refresh(){
            this.filter = {
                status: null,
                name: null,
                regNoOrId: null,
                code: null
            }
            this.getData()
        },
        getData: async function () {
            this.initializing = true

            try {
                if (!this.$route.params.checkpointId) {
                    this.initializing = false
                    return
                }

                const res = await http.post('/api/checkpoints/get-checkins', { eventId: this.$route.params.eventId, checkpointId: this.$route.params.checkpointId });
                
                this.checkins = res.data.checkins;
                this.checkinsBackup = res.data.checkins;
                
                const cf = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`);
                this.checkpointFields = cf.data.fields;

                const cfd = await http.get(`/api/checkpointfields-data/admin?eventId=${this.$route.params.eventId}`);
                this.fieldDatas = cfd.data.data;


            } catch (error) {
                this.$store.dispatch('handleErrors', error)
                console.log(error);
                this.$notify({
                    message: "something went wrong",
                    type: "danger"
                })
            }

            this.initializing = false
        },
        getNameFromRegistration(registration){
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (lastName) name += lastName.value + ','
            if (firstName) name += firstName.value

            return name
        },
        async updateFields(){
            this.editData.loading = true
            try {
                const res = await http.post(`/api/checkpointfields-data/update-fields`, {
                    eventId: this.$route.params.eventId,
                    checkpointFieldData: this.editData.recordedCheckpointFieldData
                })
                this.$notify(res.data.message);
                let found = this.fieldDatas.find(el => el.registration == this.editData.registration._id);
                if(found) found.fields = this.editData.recordedCheckpointFieldData[0].fields;
                else this.fieldDatas.push({
                    registration: this.editData.registration._id,
                    fields: this.editData.recordedCheckpointFieldData[0].fields,
                    eventId: this.$route.params.eventId,
                    _id: new Date().getTime
                })
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
            this.resetEditData();
        },
        resetEditData(){
            this.editData.fields = []
            this.editData.registration = {}
            this.editData.recordedCheckpointFieldData = []
            this.editData.dialogOpen = false
            this.editData.loading = false
        },
        async downloadAsReport(){
            let fieldNames = ['Name', 'Timestamp', 'Code',  'Status', 'Printed', 'Count', 'Registration Number', 'Registration Id', 'Note' ];
            let fieldValues = []
            let valueArr = []
            this.checkins.forEach(ch =>{
                ch.attendees.forEach(at =>{
                    let names = this.getNameFromRegistration(at).split(',');
                    let fullName = (names[1] ? names[1] : '') + ' ' + (names[0] ? names[0] : '')
                    valueArr = [ 
                        fullName, 
                        moment(ch.createdAt).format('DD MMM YYYY HH:mm'), 
                        ch.code, 
                        ch.status,
                        ch.printed,
                        ch.attendees.length,
                        ch.confirmationNumber,
                        at._id,
                        ch.note
                    ];
                    this.fieldsToShow.forEach(f =>{
                        let value = this.getValueForField(f._id, at);
                        if(!fieldNames.includes(f.title)) fieldNames.push(f.title)
                        valueArr.push(value);
                    })

                    fieldValues.push([...valueArr]);
                    valueArr = []
                })
            });

            this.downloading = true
            try {
                const response = await http.post('/api/checkpoints/attendees-log',{
                    fieldNames,
                    fieldValues
                },{
                    responseType: 'arraybuffer'
                })
                download(response.data, 'checkpoint-attendees.xlsx', '	application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                this.$notify("Generated Checkpoint Attendees Report")
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list')
            }
            this.downloading = false

        },
        getCreator(creator){
            if(!creator) return ""
            if(typeof creator == "string"){
                return creator;
            }
            return creator.email ? creator.email : ""
        }
    },
    async mounted() {
        let params = { filters: { eventId: this.$route.params.eventId } }
        if(!this.fields.length) await this.$store.dispatch('getAll', { path: 'fields', params })
        
        if(!this.checkpoints.length) 
        await this.$store.dispatch('getAll', {
            path: 'checkpoints',
            params: {
                filters: {
                    eventId: this.$route.params.eventId
                }
            }
        });
        this.checkpoint = this.checkpoints.find(el => el._id == this.checkpointId);

        await this.getData();

        this.fields.forEach(el =>{
            if(this.checkpoint.fieldsForCheckinAndAttendeesPage.includes(el._id)){
                this.fieldsToShow.push(el)
            }
        });
        
        this.checkpointFields.forEach(el =>{
            if(this.checkpoint.fieldsForCheckinAndAttendeesPage.includes(el._id)){
                this.fieldsToShow.push(el)
            }
        });
    },
    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName.value

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    }
}
</script>

<style scoped>
.tables{
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.attendees__checkin-container{
    padding: 20px;
}

.attendees__heading{
    width:70%; 
    display: flex; 
    gap:10px; 
    justify-content: space-between; 
    font-weight: bold;
    font-size: 1rem;
    color: rgb(0, 149, 0);
}

.attendees__details-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.attendees__details{
    width:70%;
    display: flex; 
    gap:10px; 
    justify-content: space-between;
}

.responsive-table {
    width: 100%;
    overflow-x: auto;
    position: relative;
}




/* Style the table */
table {
    width: 100%;
    border-collapse: collapse;
}

/* Style the table header */
th {
    background-color: #f2f2f2;
    color: black;
    padding: 15px;
    text-align: center;
}

th:nth-child(1){
    text-align: left;
}
/* Style the table cells */
td {
    border: 1px solid #ddd;
    padding: 10px 15px;
    text-align: center;
}

td:nth-child(1){
    text-align: left;
}

/* Add a hover effect to the rows */
tr:hover {
    background-color: #f5f5f5;
}

.status-tag{
    width: max-content;
}
</style>